/** Denetim eylemlerinin Türkçe karşılıkları ve renkleri. */
const LABELS: Record<string, string> = {
  LOGIN_SUCCESS: 'Giriş yapıldı',
  LOGIN_FAILED: 'Başarısız giriş denemesi',
  ACCOUNT_LOCKED: 'Hesap kilitlendi',
  LOGOUT: 'Çıkış yapıldı',
  LOGOUT_ALL: 'Tüm oturumlar kapatıldı',
  PASSWORD_CHANGED: 'Parola değiştirildi',
  REFRESH_TOKEN_REUSE: 'Şüpheli oturum kullanımı',
  PASSWORD_RESET_REQUESTED: 'Parola sıfırlama bağlantısı istendi',
  PASSWORD_RESET_COMPLETED: 'Parola bağlantıyla sıfırlandı',

  USER_CREATED: 'Kullanıcı oluşturuldu',
  USER_UPDATED: 'Kullanıcı güncellendi',
  USER_ENABLED: 'Hesap etkinleştirildi',
  USER_DISABLED: 'Hesap devre dışı bırakıldı',
  USER_PASSWORD_RESET: 'Parola sıfırlandı',
  USER_FORCE_LOGOUT: 'Oturumlar sonlandırıldı',
  USER_ROLES_CHANGED: 'Roller değiştirildi',
  USER_INVITED: 'Davet bağlantısı gönderildi',
  INVITE_ACCEPTED: 'Davet kabul edildi',
  TWO_FACTOR_ENABLED: 'İki adımlı doğrulama açıldı',
  TWO_FACTOR_DISABLED: 'İki adımlı doğrulama kapatıldı',
  TWO_FACTOR_VERIFIED: 'Mobilde doğrulama kodu girildi',
  MOBILE_ACCESS_ENABLED: 'Mobil erişim açıldı',
  MOBILE_ACCESS_DISABLED: 'Mobil erişim kapatıldı',

  PROJECT_CREATED: 'Proje oluşturuldu',
  PROJECT_UPDATED: 'Proje güncellendi',
  PROJECT_DELETED: 'Proje silindi',
  PROJECT_RESTORED: 'Proje geri yüklendi',
  PROJECT_VISIBILITY_CHANGED: 'Görünürlük değiştirildi',
  MEMBER_ADDED: 'Üye eklendi',
  MEMBER_ROLE_CHANGED: 'Üye rolü değişti',
  MEMBER_REMOVED: 'Üye çıkarıldı',
  OWNERSHIP_TRANSFERRED: 'Sahiplik devredildi',

  TEAM_CREATED: 'Ekip oluşturuldu',
  TEAM_UPDATED: 'Ekip güncellendi',
  TEAM_DELETED: 'Ekip silindi',
  TEAM_MEMBER_ADDED: 'Ekibe üye eklendi',
  TEAM_MEMBER_REMOVED: 'Ekipten üye çıkarıldı',
  PROJECT_TEAM_ADDED: 'Projeye ekip eklendi',
  PROJECT_TEAM_ROLE_CHANGED: 'Ekibin rolü değişti',
  PROJECT_TEAM_REMOVED: 'Ekip projeden kaldırıldı',

  NOTE_CREATED: 'Not oluşturuldu',
  NOTE_UPDATED: 'Not güncellendi',
  NOTE_DELETED: 'Not silindi',
  NOTE_RESTORED: 'Not geri yüklendi',
  NOTE_VERSION_RESTORED: 'Not sürümü geri yüklendi',

  FILE_UPLOADED: 'Dosya yüklendi',
  FILE_UPDATED: 'Dosya güncellendi',
  FILE_DELETED: 'Dosya silindi',
  FILE_RESTORED: 'Dosya geri yüklendi',
  FILE_DOWNLOADED: 'Dosya indirildi',
  FILE_VERSION_CREATED: 'Yeni dosya sürümü',
  FILE_VERSION_RESTORED: 'Dosya sürümü geri yüklendi',

  SHARE_LINK_CREATED: 'Paylaşım linki oluşturuldu',
  SHARE_LINK_REVOKED: 'Paylaşım linki iptal edildi',

  VAULT_ENTRY_CREATED: 'Kasa kaydı oluşturuldu',
  VAULT_ENTRY_UPDATED: 'Kasa kaydı güncellendi',
  VAULT_ENTRY_DELETED: 'Kasa kaydı silindi',
  VAULT_ENTRY_VIEWED: 'Kasa kaydı görüntülendi',

  TASK_CREATED: 'Görev oluşturuldu',
  TASK_UPDATED: 'Görev güncellendi',
  TASK_MOVED: 'Görev taşındı',
  TASK_DELETED: 'Görev silindi',
  TASK_COMMENTED: 'Göreve yorum yazıldı',
  TASK_ATTACHMENT_ADDED: 'Göreve dosya eklendi',
  TASK_ATTACHMENT_REMOVED: 'Görevden dosya kaldırıldı',
  PROJECT_STAGE_CHANGED: 'Proje durumu değişti',
  STAGE_CREATED: 'Proje durumu tanımlandı',
  STAGE_UPDATED: 'Proje durumu düzenlendi',
  STAGE_DELETED: 'Proje durumu kaldırıldı',

  SNIPPET_CREATED: 'Kod oluşturuldu',
  SNIPPET_UPDATED: 'Kod güncellendi',
  SNIPPET_DELETED: 'Kod silindi',

  ADMIN_OVERRIDE_READ: 'Yönetici erişimi',

  MAIL_SETTINGS_UPDATED: 'E-posta ayarları değiştirildi',
  MAIL_EVENTS_UPDATED: 'E-posta bildirimleri değiştirildi',
  MAIL_TEST_SENT: 'Sınama postası gönderildi',
  MAIL_DIGEST_SENT: 'Günlük iş özeti elle gönderildi',

  TEST_SUITE_IMPORTED: 'Test senaryoları içe aktarıldı',
  TEST_SUITE_DELETED: 'Test senaryo seti silindi',
  TEST_RUN_CREATED: 'Test koşumu oluşturuldu',
  TEST_RUN_UPDATED: 'Test koşumu güncellendi',
  TEST_RUN_DELETED: 'Test koşumu silindi',
  TEST_ASSIGNED: 'Test ataması yapıldı',
  TEST_EXPORTED: 'Test sonuçları dışa aktarıldı',

  DEPLOY_CREDENTIAL_SAVED: 'Deploy kimlik bilgisi kaydedildi',
  DEPLOY_CREDENTIAL_DELETED: 'Deploy kimlik bilgisi silindi',
  DEPLOY_SERVER_SAVED: 'Deploy sunucusu kaydedildi',
  DEPLOY_SERVER_DELETED: 'Deploy sunucusu silindi',
  DEPLOY_ENVIRONMENT_SAVED: 'Deploy ortamı kaydedildi',
  DEPLOY_ENVIRONMENT_DELETED: 'Deploy ortamı silindi',
  DEPLOY_JOB_SAVED: 'Deploy işi kaydedildi',
  DEPLOY_JOB_DELETED: 'Deploy işi silindi',
  DEPLOY_RUN_STARTED: 'Deploy başlatıldı',
  DEPLOY_RUN_CANCELLED: 'Deploy iptal edildi',
  OFFER_CREATED: 'Teklif oluşturuldu',
  OFFER_UPDATED: 'Teklif güncellendi',
  OFFER_DELETED: 'Teklif silindi',
  OFFER_DOCUMENT_ADDED: 'Teklife doküman eklendi',
  OFFER_DOCUMENT_REMOVED: 'Tekliften doküman kaldırıldı',
  OFFER_REMINDER_SAVED: 'Teklif hatırlatıcısı kaydedildi',
  OFFER_REMINDER_DELETED: 'Teklif hatırlatıcısı silindi',
}

const DANGER = new Set([
  'LOGIN_FAILED', 'ACCOUNT_LOCKED', 'REFRESH_TOKEN_REUSE',
  'USER_DISABLED', 'PROJECT_DELETED', 'NOTE_DELETED', 'FILE_DELETED',
  'TWO_FACTOR_DISABLED', 'ADMIN_OVERRIDE_READ', 'TEAM_DELETED', 'MOBILE_ACCESS_DISABLED',
  'TEST_SUITE_DELETED', 'TEST_RUN_DELETED', 'VAULT_ENTRY_DELETED',
  'TASK_DELETED', 'STAGE_DELETED', 'SNIPPET_DELETED',
  'DEPLOY_CREDENTIAL_DELETED', 'DEPLOY_SERVER_DELETED', 'DEPLOY_ENVIRONMENT_DELETED', 'DEPLOY_JOB_DELETED',
  'DEPLOY_RUN_CANCELLED', 'OFFER_DELETED',
])
const SUCCESS = new Set([
  'USER_CREATED', 'PROJECT_CREATED', 'NOTE_CREATED', 'FILE_UPLOADED', 'USER_ENABLED',
  'TWO_FACTOR_ENABLED', 'TEAM_CREATED', 'TEST_SUITE_IMPORTED', 'TEST_RUN_CREATED',
  'VAULT_ENTRY_CREATED', 'TASK_CREATED', 'SNIPPET_CREATED', 'DEPLOY_RUN_STARTED',
  'OFFER_CREATED',
])

/** Etiketi olan bütün işlemler (denetim süzgeci listesi buradan türer). */
export const AUDIT_ACTIONS: readonly string[] = Object.keys(LABELS)
/** Kategori süzgeci: riskli (kırmızı) ve oluşturma (yeşil) işlemleri. */
export const AUDIT_DANGER: readonly string[] = [...DANGER]
export const AUDIT_SUCCESS: readonly string[] = [...SUCCESS]

export function auditLabel(action: string): string {
  return LABELS[action] ?? action
}

export function auditColor(action: string): string {
  if (DANGER.has(action)) return 'red'
  if (SUCCESS.has(action)) return 'green'
  return 'gray'
}

/** details jsonb'sinden okunabilir bir özet çıkarır. */
export function auditDetail(details: Record<string, unknown> | null): string {
  if (!details) return ''
  const d = details as Record<string, string | number>
  return (
    (d.name as string) ||
    (d.title as string) ||
    (d.username as string) ||
    (d.role as string) ||
    (d.visibility as string) ||
    (d.team as string) ||
    ''
  )
}
